import { render } from "./TagTypeInfoDialog.vue?vue&type=template&id=1f6a58c6&scoped=true"
import script from "./TagTypeInfoDialog.vue?vue&type=script&lang=js"
export * from "./TagTypeInfoDialog.vue?vue&type=script&lang=js"

import "./TagTypeInfoDialog.vue?vue&type=style&index=0&id=1f6a58c6&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6a58c6"]])

export default __exports__